const haveInsuranceScores = [
    { min: 0, max: 18, haveInsurance: true, score: -20 },
    { min: 18, max: 27, haveInsurance: true, score: 2 },
    { min: 27, max: 40, haveInsurance: true, score: 2 },
    { min: 40, max: 55, haveInsurance: true, score: 2 },
    { min: 55, max: 200, haveInsurance: true, score: 2 },

    { min: 0, max: 18, haveInsurance: false, score: -20 },
    { min: 18, max: 27, haveInsurance: false, score: -3 },
    { min: 27, max: 40, haveInsurance: false, score: -5 },
    { min: 40, max: 55, haveInsurance: false, score: -5 },
    { min: 55, max: 200, haveInsurance: false, score: -5 }
];

export default haveInsuranceScores;
